// extracted by mini-css-extract-plugin
module.exports = {"MobileDropdownText":"_1TRvMZ7dS7pQtgun6sw592"};